export const siteSettings = {
  name: "Trust Vault",
  link: "https://trustvault.pro",
  email: "support@trustvault.pro",
  appLink: "https://app.trustvault.pro",
};
